import { useEffect } from "react";

import { useAppState } from "../../../context/StateContext";
import useActionCustomers from "../../../hooks/useActionCustomer";
import useActionPurchaseOrder from "../../../hooks/useActionPurchaseOrder";
import { usePurchaseOrderContext } from "../../../hooks/usePurchaseOrderContext";
import { Port } from "../../../models/port";
import { PurchaseOrder } from "../../../models/purchase.order";

interface UsePurchaseOrdersProps {
  purchaseOrder?: PurchaseOrder;
  portCodes?: Port[];
}

export const usePurchaseOrderDetails = ({ purchaseOrder, portCodes }: UsePurchaseOrdersProps) => {
  const { currentUser, isFMorSPVersion } = useAppState();
  const { getAllCustomers } = useActionCustomers();
  const { setMilestoneDates } = usePurchaseOrderContext();

  const { getOrderMilestoneDates } = useActionPurchaseOrder();
  const { data: milestones, isFetching: fetchingMilestones } = getOrderMilestoneDates(
    purchaseOrder?.companyId || currentUser?.companyId
  );

  const { data: customerOptions, isFetching: loadingCustomers } = getAllCustomers({
    companyId: purchaseOrder?.companyId || currentUser?.companyId,
  });

  const originPortSelected =
    isFMorSPVersion && purchaseOrder?.originPort
      ? purchaseOrder?.originPort
      : portCodes?.find((port) => Number(purchaseOrder?.originPortId) === Number(port.id));

  const destinationPortSelected =
    isFMorSPVersion && purchaseOrder?.destinationPort
      ? purchaseOrder?.destinationPort
      : portCodes?.find((port) => Number(purchaseOrder?.destinationPortId) === Number(port.id));

  const customerSelected =
    customerOptions &&
    customerOptions.find((customer) => Number(purchaseOrder?.consigneeId) === Number(customer?.id));

  useEffect(() => {
    if (milestones && milestones instanceof Array) {
      setMilestoneDates(milestones);
    }
  }, [milestones]);

  return {
    originPortSelected,
    destinationPortSelected,
    customerSelected,
    loadingCustomers,
    customerOptions,
    fetchingMilestones,
  };
};
